import React from 'react';

import { Grid, Typography } from '@mui/material';
import { SelectArrayInput } from 'react-admin';
import { countryChoices } from '../../../constants/countries';
import CommentInput from '../../comment/CommentInput';

const Residence = () => (

  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Country
      </Typography>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 7,
      }}
    >
      <Grid container />
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectArrayInput fullWidth choices={countryChoices('en')} source="value" />
      </Grid>
      <Grid size={12}>
        <CommentInput
          source="comment"
          helperText={false}
          placeholder="Please explain your decision."
        />
      </Grid>
    </Grid>
  </Grid>

);

export default Residence;
